import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {AuthorizeNetPaymentProfileDto} from "../model/AuthorizeNetPaymentProfileDto";
import {DisposeBag} from "../modules/DisposeBag";

class CustomerPaymentProfileSelectController implements IComponentController {
    records: AuthorizeNetPaymentProfileDto[] = [];
    model: AuthorizeNetPaymentProfileDto;
    onSelect: Function;
    required: string;
    placeholder: string;
    customerGuid: string;
    showAll: Boolean;
    private disposeBag = new DisposeBag();

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.bindAllPaymentProfile(() => this.records, this.disposeBag);
        $dataHub.onConnected(this.reload, this.disposeBag);
        $scope.$watch(() => this.customerGuid, this.reload)
    }

    reload = () => {
        this.records = [];
        if(this.customerGuid)
            this.$dataHub.paymentProfileSub(this.customerGuid);
    };

    $onInit(): void {
    }

    $onDestroy() {
        this.disposeBag.finalize();
    }
}

export default angular.module('component.customerPaymentProfileSelect', [])
    .component('customerPaymentProfileSelect', {
        template: require('./CustomerPaymentProfileSelect.html'),
        controller: CustomerPaymentProfileSelectController,
        bindings: {
            model: '=',
            onSelect: '&',
            required: '=',
            placeholder: '@',
            showAll: '=',
            allowClear: '=',
            customerGuid: '='
        }
    }).name;
